import axios from 'axios';
import aegisNodeSdk from '@tencent/aegis-node-sdk';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign$1 = function () {
  __assign$1 = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$1.apply(this, arguments);
};
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */

/**
 * Module exports.
 * @public
 */
var parse_1 = parse;
var serialize_1 = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }
  var obj = {};
  var opt = options || {};
  var pairs = str.split(';');
  var dec = opt.decode || decode;
  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var index = pair.indexOf('=');

    // skip things that don't look like key=value
    if (index < 0) {
      continue;
    }
    var key = pair.substring(0, index).trim();

    // only assign once
    if (undefined == obj[key]) {
      var val = pair.substring(index + 1, pair.length).trim();

      // quoted values
      if (val[0] === '"') {
        val = val.slice(1, -1);
      }
      obj[key] = tryDecode(val, dec);
    }
  }
  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;
  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }
  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }
  var value = enc(val);
  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }
  var str = name + '=' + value;
  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid');
    }
    str += '; Max-Age=' + Math.floor(maxAge);
  }
  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }
    str += '; Domain=' + opt.domain;
  }
  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }
    str += '; Path=' + opt.path;
  }
  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }
    str += '; Expires=' + opt.expires.toUTCString();
  }
  if (opt.httpOnly) {
    str += '; HttpOnly';
  }
  if (opt.secure) {
    str += '; Secure';
  }
  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }
  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}

function hasDocumentCookie() {
  // Can we get/set cookies on document.cookie?
  return typeof document === 'object' && typeof document.cookie === 'string';
}
function parseCookies(cookies, options) {
  if (typeof cookies === 'string') {
    return parse_1(cookies, options);
  } else if (typeof cookies === 'object' && cookies !== null) {
    return cookies;
  } else {
    return {};
  }
}
function isParsingCookie(value, doNotParse) {
  if (typeof doNotParse === 'undefined') {
    // We guess if the cookie start with { or [, it has been serialized
    doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
  }
  return !doNotParse;
}
function readCookie(value, options) {
  if (options === void 0) {
    options = {};
  }
  var cleanValue = cleanupCookieValue(value);
  if (isParsingCookie(cleanValue, options.doNotParse)) {
    try {
      return JSON.parse(cleanValue);
    } catch (e) {
      // At least we tried
    }
  }
  // Ignore clean value if we failed the deserialization
  // It is not relevant anymore to trim those values
  return value;
}
function cleanupCookieValue(value) {
  // express prepend j: before serializing a cookie
  if (value && value[0] === 'j' && value[1] === ':') {
    return value.substr(2);
  }
  return value;
}

var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var Cookies$1 = /** @class */function () {
  function Cookies(cookies, options) {
    var _this = this;
    this.changeListeners = [];
    this.HAS_DOCUMENT_COOKIE = false;
    this.cookies = parseCookies(cookies, options);
    new Promise(function () {
      _this.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
    }).catch(function () {});
  }
  Cookies.prototype._updateBrowserValues = function (parseOptions) {
    if (!this.HAS_DOCUMENT_COOKIE) {
      return;
    }
    this.cookies = parse_1(document.cookie, parseOptions);
  };
  Cookies.prototype._emitChange = function (params) {
    for (var i = 0; i < this.changeListeners.length; ++i) {
      this.changeListeners[i](params);
    }
  };
  Cookies.prototype.get = function (name, options, parseOptions) {
    if (options === void 0) {
      options = {};
    }
    this._updateBrowserValues(parseOptions);
    return readCookie(this.cookies[name], options);
  };
  Cookies.prototype.getAll = function (options, parseOptions) {
    if (options === void 0) {
      options = {};
    }
    this._updateBrowserValues(parseOptions);
    var result = {};
    for (var name_1 in this.cookies) {
      result[name_1] = readCookie(this.cookies[name_1], options);
    }
    return result;
  };
  Cookies.prototype.set = function (name, value, options) {
    var _a;
    if (typeof value === 'object') {
      value = JSON.stringify(value);
    }
    this.cookies = __assign(__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
    if (this.HAS_DOCUMENT_COOKIE) {
      document.cookie = serialize_1(name, value, options);
    }
    this._emitChange({
      name: name,
      value: value,
      options: options
    });
  };
  Cookies.prototype.remove = function (name, options) {
    var finalOptions = options = __assign(__assign({}, options), {
      expires: new Date(1970, 1, 1, 0, 0, 1),
      maxAge: 0
    });
    this.cookies = __assign({}, this.cookies);
    delete this.cookies[name];
    if (this.HAS_DOCUMENT_COOKIE) {
      document.cookie = serialize_1(name, '', finalOptions);
    }
    this._emitChange({
      name: name,
      value: undefined,
      options: options
    });
  };
  Cookies.prototype.addChangeListener = function (callback) {
    this.changeListeners.push(callback);
  };
  Cookies.prototype.removeChangeListener = function (callback) {
    var idx = this.changeListeners.indexOf(callback);
    if (idx >= 0) {
      this.changeListeners.splice(idx, 1);
    }
  };
  return Cookies;
}();
var Cookies$2 = Cookies$1;

var Cookies = Cookies$2;
// we seem to sometimes get the ES6 version despite requesting cjs here, not sure why
// this isn't the ideal fix, but it'll do for now
Cookies = Cookies.default || Cookies;
function nextCookies(ctx, options) {
  // Note: Next.js Static export sets ctx.req to a fake request with no headers
  var header = ctx.req && ctx.req.headers && ctx.req.headers.cookie;
  var uc = new Cookies(header);
  return uc.getAll(options);
}
var nextCookies_1 = nextCookies;

var IS_SERVER$1 = typeof window === 'undefined';
var isServer$1 = IS_SERVER$1;

var cookie = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, '__esModule', {
    value: true
  });
  function _interopDefaultLegacy(e) {
    return e && typeof e === 'object' && 'default' in e ? e : {
      'default': e
    };
  }
  var nextCookies__default = /*#__PURE__*/_interopDefaultLegacy(nextCookies_1);

  /*! js-cookie v3.0.1 | MIT */

  /* eslint-disable no-var */
  function assign(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        target[key] = source[key];
      }
    }
    return target;
  }
  /* eslint-enable no-var */

  /* eslint-disable no-var */

  var defaultConverter = {
    read: function (value) {
      if (value[0] === '"') {
        value = value.slice(1, -1);
      }
      return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
    },
    write: function (value) {
      return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
    }
  };
  /* eslint-enable no-var */

  /* eslint-disable no-var */

  function init(converter, defaultAttributes) {
    function set(key, value, attributes) {
      if (typeof document === 'undefined') {
        return;
      }
      attributes = assign({}, defaultAttributes, attributes);
      if (typeof attributes.expires === 'number') {
        attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
      }
      if (attributes.expires) {
        attributes.expires = attributes.expires.toUTCString();
      }
      key = encodeURIComponent(key).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var stringifiedAttributes = '';
      for (var attributeName in attributes) {
        if (!attributes[attributeName]) {
          continue;
        }
        stringifiedAttributes += '; ' + attributeName;
        if (attributes[attributeName] === true) {
          continue;
        } // Considers RFC 6265 section 5.2:
        // ...
        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...

        stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
      }
      return document.cookie = key + '=' + converter.write(value, key) + stringifiedAttributes;
    }
    function get(key) {
      if (typeof document === 'undefined' || arguments.length && !key) {
        return;
      } // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all.

      var cookies = document.cookie ? document.cookie.split('; ') : [];
      var jar = {};
      for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var value = parts.slice(1).join('=');
        try {
          var foundKey = decodeURIComponent(parts[0]);
          jar[foundKey] = converter.read(value, foundKey);
          if (key === foundKey) {
            break;
          }
        } catch (e) {}
      }
      return key ? jar[key] : jar;
    }
    return Object.create({
      set: set,
      get: get,
      remove: function (key, attributes) {
        set(key, '', assign({}, attributes, {
          expires: -1
        }));
      },
      withAttributes: function (attributes) {
        return init(this.converter, assign({}, this.attributes, attributes));
      },
      withConverter: function (converter) {
        return init(assign({}, this.converter, converter), this.attributes);
      }
    }, {
      attributes: {
        value: Object.freeze(defaultAttributes)
      },
      converter: {
        value: Object.freeze(converter)
      }
    });
  }
  var api = init(defaultConverter, {
    path: '/'
  });

  /*
   * @Date: 2022-07-08 23:54:24
   * @Author: manuelzhao
   * @LastEditors: venlerwei
   * @LastEditTime: 2022-08-16 20:13:30
   * @Description: file content
   * @FilePath: /calendar-create-app/plugins/request/lib/cookies.js
   */

  var getAllCookies = function (ctx) {
    if (ctx && isServer$1) {
      return nextCookies__default["default"](ctx);
    }
    return api.get();
  };
  var setCookies = function (name, value, option) {
    if (name === void 0) {
      name = '';
    }
    if (value === void 0) {
      value = '';
    }
    if (option === void 0) {
      option = {};
    }
    if (isServer$1) {
      return false;
    }
    api.set(name, value, option);
    return true;
  };
  exports.getAllCookies = getAllCookies;
  exports.setCookies = setCookies;
});
unwrapExports(cookie);
cookie.getAllCookies;
var cookie_2 = cookie.setCookies;

var url = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, '__esModule', {
    value: true
  });

  /*
   * @Author: venler
   * @Date: 2022-08-16 20:15:21
   * @LastEditors: venlerwei
   * @LastEditTime: 2022-08-16 20:15:22
   * @Description: Do not edit
   */
  function addURLSearch(url, options) {
    if (options === void 0) {
      options = {};
    }
    var urlArr = url.split('?');
    var dealSearchStr = function (obj, options, hash) {
      if (obj === void 0) {
        obj = {};
      }
      if (options === void 0) {
        options = {};
      }
      if (hash === void 0) {
        hash = '';
      }
      var searchStr = '';
      var tmp = Object.assign({}, obj, options);
      var t = 0;
      Object.keys(tmp).forEach(function (key) {
        searchStr += "".concat((t !== 0 ? '&' : '') + key, "=").concat(tmp[key]);
        t = t + 1;
      });
      if (hash) {
        // add hash #
        searchStr += "#".concat(hash);
      }
      if (t !== 0) {
        // add ?
        searchStr = "?".concat(searchStr);
      }
      return searchStr;
    };
    var resStr = '';
    if (urlArr[1]) {
      // extract location.search
      var searchArr = urlArr[1].split('#');
      var lists = searchArr[0].split('&');
      var obj_1 = {};
      lists.forEach(function (list) {
        var arr = list.split('=');
        obj_1[arr[0]] = arr[1] || '';
      });
      resStr = dealSearchStr(obj_1, options, searchArr[1]);
    } else {
      resStr = dealSearchStr({}, options, urlArr[0].split('#')[1]);
    }
    return urlArr[0] + resStr;
  }
  function deleteURLSearch(url, key) {
    if (url === void 0) {
      url = window.location.href;
    }
    var urlArr = url.split('?');
    var resStr = '';
    if (urlArr[1]) {
      // extract location.search
      var searchArr = urlArr[1].split('#');
      var lists = searchArr[0].split('&');
      var obj = {}; // eslint-disable-next-line no-restricted-syntax

      for (var i in lists) {
        var arr = lists[i].split('=');
        if (arr[0] !== key) {
          // 与 addURLSearch 的区别; 另外dealSearchStr的 options 为 {}
          obj[arr[0]] = arr[1] || '';
        }
      }
      resStr = dealSearchStr(obj, {}, searchArr[1]);
    } else {
      resStr = dealSearchStr({}, {}, urlArr[0].split('#')[1]);
    }
    return urlArr[0] + resStr;
  }
  var dealSearchStr = function (obj, options, hash) {
    if (obj === void 0) {
      obj = {};
    }
    if (options === void 0) {
      options = {};
    }
    if (hash === void 0) {
      hash = '';
    }
    var searchStr = '';
    var tmp = Object.assign({}, obj, options);
    var t = 0; // eslint-disable-next-line no-restricted-syntax

    for (var i in tmp) {
      searchStr += "".concat((t !== 0 ? '&' : '') + i, "=").concat(tmp[i]);
      t = t + 1;
    }
    if (hash) {
      // add hash #
      searchStr += "#".concat(hash);
    }
    if (t !== 0) {
      // add ?
      searchStr = "?".concat(searchStr);
    }
    return searchStr;
  };
  function getRequest(name, url) {
    var urlSearch = url;
    if (!urlSearch) {
      urlSearch = window.location.href.split('?')[1];
    } else if (urlSearch.split('?')[1]) {
      urlSearch = urlSearch.split('?')[1];
    } // 去除 hash 值

    if (urlSearch) {
      urlSearch = String(urlSearch).split('#')[0];
    }
    var res = new RegExp("(^|&)".concat(name, "=([^&]*)")).exec(urlSearch);
    return !!res && res[2];
  }
  exports.addURLSearch = addURLSearch;
  exports.deleteURLSearch = deleteURLSearch;
  exports.getRequest = getRequest;
});
unwrapExports(url);
var url_1 = url.addURLSearch;
var url_2 = url.deleteURLSearch;
var url_3 = url.getRequest;

var tslib_es629fb0173 = createCommonjsModule(function (module, exports) {

  /******************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */
  exports.__assign = function () {
    exports.__assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
    };
    return exports.__assign.apply(this, arguments);
  };
  function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function (resolve) {
        resolve(value);
      });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  }
  function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function () {
          if (t[0] & 1) throw t[1];
          return t[1];
        },
        trys: [],
        ops: []
      },
      f,
      y,
      t,
      g;
    return g = {
      next: verb(0),
      "throw": verb(1),
      "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
      return this;
    }), g;
    function verb(n) {
      return function (v) {
        return step([n, v]);
      };
    }
    function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
      if (op[0] & 5) throw op[1];
      return {
        value: op[0] ? op[1] : void 0,
        done: true
      };
    }
  }
  function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
        if (!ar) ar = Array.prototype.slice.call(from, 0, i);
        ar[i] = from[i];
      }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
  }
  exports.__awaiter = __awaiter;
  exports.__generator = __generator;
  exports.__spreadArray = __spreadArray;
});
tslib_es629fb0173.__assign;
tslib_es629fb0173.__awaiter;
tslib_es629fb0173.__generator;
tslib_es629fb0173.__spreadArray;

function _interopDefaultLegacy$1(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var cookies__default = /*#__PURE__*/_interopDefaultLegacy$1(nextCookies_1);

/*! js-cookie v3.0.1 | MIT */
/* eslint-disable no-var */
function assign(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target;
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function (value) {
    return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init$1(converter, defaultAttributes) {
  function set(key, value, attributes) {
    if (typeof document === 'undefined') {
      return;
    }
    attributes = assign({}, defaultAttributes, attributes);
    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }
    key = encodeURIComponent(key).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue;
      }
      stringifiedAttributes += '; ' + attributeName;
      if (attributes[attributeName] === true) {
        continue;
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }
    return document.cookie = key + '=' + converter.write(value, key) + stringifiedAttributes;
  }
  function get(key) {
    if (typeof document === 'undefined' || arguments.length && !key) {
      return;
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');
      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);
        if (key === foundKey) {
          break;
        }
      } catch (e) {}
    }
    return key ? jar[key] : jar;
  }
  return Object.create({
    set: set,
    get: get,
    remove: function (key, attributes) {
      set(key, '', assign({}, attributes, {
        expires: -1
      }));
    },
    withAttributes: function (attributes) {
      return init$1(this.converter, assign({}, this.attributes, attributes));
    },
    withConverter: function (converter) {
      return init$1(assign({}, this.converter, converter), this.attributes);
    }
  }, {
    attributes: {
      value: Object.freeze(defaultAttributes)
    },
    converter: {
      value: Object.freeze(converter)
    }
  });
}
var api = init$1(defaultConverter, {
  path: '/'
});
var IS_SERVER = typeof window === 'undefined';
var isServer = IS_SERVER;

/*
 * @Date: 2022-07-08 23:54:24
 * @Author: manuelzhao
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-05-04 23:00:06
 * @Description: file content
 * @FilePath: /calendar-framework/packages/request/lib/cookies.js
 */
// 获取所有的cookie
const getAllCookies = ctx => {
  if (ctx && isServer) {
    return cookies__default["default"](ctx) || {};
  }
  return api.get() || {};
};
const setCookies = (name = '', value = '', option = {}) => {
  if (isServer) {
    return false;
  }
  api.set(name, value, option);
  return true;
};
var getAllCookies_1 = getAllCookies;
var isServer_1 = isServer;
var setCookies_1 = setCookies;
var cookies4cd4f1c3 = {
  getAllCookies: getAllCookies_1,
  isServer: isServer_1,
  setCookies: setCookies_1
};

var _commonjsHelpersAad7be82 = createCommonjsModule(function (module, exports) {

  function unwrapExports(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }
  function createCommonjsModule(fn, module) {
    return module = {
      exports: {}
    }, fn(module, module.exports), module.exports;
  }
  exports.createCommonjsModule = createCommonjsModule;
  exports.unwrapExports = unwrapExports;
});
unwrapExports(_commonjsHelpersAad7be82);
_commonjsHelpersAad7be82.createCommonjsModule;
_commonjsHelpersAad7be82.unwrapExports;

var nodeAegisE2e89eff = createCommonjsModule(function (module, exports) {

  var cookies$1 = nextCookies_1;
  function _interopDefaultLegacy(e) {
    return e && typeof e === 'object' && 'default' in e ? e : {
      'default': e
    };
  }
  function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function () {
              return e[k];
            }
          });
        }
      });
    }
    n["default"] = e;
    return Object.freeze(n);
  }
  var cookies__default = /*#__PURE__*/_interopDefaultLegacy(cookies$1);

  /*
   * @Date: 2022-06-06 08:40:48
   * @Author: manuelzhao
   * @LastEditors: manuelzhao
   * @LastEditTime: 2022-06-06 08:41:16
   * @Description: 判断UA
   * @FilePath: /calendar-create-app/utils/get-user-agent.ts
   */
  /**
   * 获取UserAgent
   * @param ctx
   */

  function getNextUserAgent(ctx) {
    var _a;
    var userAgent = '';
    if (cookies4cd4f1c3.isServer) {
      userAgent = ((_a = ctx === null || ctx === void 0 ? void 0 : ctx.req) === null || _a === void 0 ? void 0 : _a.headers['user-agent']) || '';
    } else {
      userAgent = window.navigator.userAgent;
    }
    return userAgent;
  }
  var getUserAgent = getNextUserAgent;

  /**
   * 腾讯会议App
   */
  var isWeMeetApp = function (userAgent) {
    return /app\/tencent_wemeet/i.test(userAgent.toLowerCase());
  };
  /**
   * Windows 系统
   */
  var isWin = function (userAgent) {
    return /windows|win32|win64/i.test(userAgent.toLowerCase());
  };
  /**
   * mac 系统
   */
  var isMac = function (userAgent) {
    return /macintosh|mac os x/i.test(userAgent.toLowerCase());
  };
  /**
   * 安卓
   */
  var isAndroid = function (userAgent) {
    return /android|adr/i.test(userAgent.toLowerCase());
  };
  /**
   * IOS
   */
  var isIOS = function (userAgent) {
    return /iphone|ipod|ipad/i.test(userAgent.toLowerCase());
  };
  /**
   * iPhone
   */
  var isIPhone = function (userAgent) {
    return /iphone/i.test(userAgent.toLowerCase());
  };
  /**
   * iPad
   */
  var isIPad = function (userAgent) {
    return /ipad/i.test(userAgent.toLowerCase());
  };
  /**
   * Windows App
   */
  var isWinApp = function (userAgent) {
    return isWin(userAgent) && isWeMeetApp(userAgent);
  };
  /**
   * mac App
   */
  var isMacApp = function (userAgent) {
    return !isIOS(userAgent) && isMac(userAgent) && isWeMeetApp(userAgent);
  };

  /**
   终端类型定义
   enum InstanceType {
    kInstanceTypeNone         = 0,
    kInstanceTypeWin          = 1,    // PC - windows
    kInstanceTypeMac          = 2,    // Mac
    kInstanceTypeAndroid      = 3,    // Android
    kInstanceTypeIPhone       = 4,    // iPhone
    kInstanceTypeWeb          = 5,    // web
    kInstanceTypeIPad         = 6,    // iPad
    kInstanceTypeAPad         = 7,    // aPad
    kInstanceTypeMiniProgram  = 8,    // wechat mini program
  };
   */
  /**
    * Instance Id定义映射
    */
  var InstanceTypeMap = {
    0: 'None',
    1: 'Windows',
    2: 'Mac',
    3: 'Android',
    4: 'iPhone',
    5: 'Web',
    6: 'iPad',
    7: 'aPad',
    8: 'wxProgram'
  };
  /**
    * 判断终端平台类型
    * @param userAgent UA
    */
  function getInstanceId(userAgent) {
    var id = 0;
    if (isWinApp(userAgent)) {
      id = 1;
    } else if (isMacApp(userAgent)) {
      id = 2;
    } else if (isAndroid(userAgent) && isWeMeetApp(userAgent)) {
      id = 3;
    } else if (isIPhone(userAgent) && isWeMeetApp(userAgent)) {
      id = 4;
    } else if (!isWeMeetApp(userAgent)) {
      id = 5;
    } else if (isIPad(userAgent) && isWeMeetApp(userAgent)) {
      id = 6;
    }
    return {
      id: id,
      name: InstanceTypeMap[id] || ''
    };
  }

  /**
   * 腾讯会议内部版本号
   */
  function tencentAppVersion(userAgent) {
    var _a;
    var res = '';
    var ua = userAgent.toLowerCase();
    // 不是企业微信
    var regStrSaf = /app_version\/[\d._]*/gi;
    var verinfo = ua.match(regStrSaf);
    if (verinfo && verinfo.length > 0) {
      _a = verinfo[0].split('/'), res = _a[1];
    }
    return res;
  }
  var os = _commonjsHelpersAad7be82.createCommonjsModule(function (module, exports) {
    Object.defineProperty(exports, '__esModule', {
      value: true
    });

    // import { compareVersion } from '../compare-version';

    /**
     * 腾讯日历App
     */
    var isCalendarApp = function (userAgent) {
      return /app\/tencent_wecalendar/i.test(userAgent.toLowerCase());
    };
    /**
     * Windows 系统
     */

    var isWin = function (userAgent) {
      return /windows|win32|win64/i.test(userAgent.toLowerCase());
    };
    /**
     * mac 系统
     */

    var isMac = function (userAgent) {
      return /macintosh|mac os x/i.test(userAgent.toLowerCase());
    };
    /**
     * 安卓
     */

    var isAndroid = function (userAgent) {
      return /android|adr/i.test(userAgent.toLowerCase());
    };
    /**
     * IOS
     */

    var isIOS = function (userAgent) {
      return /iphone|ipod|ipad/i.test(userAgent.toLowerCase());
    };
    /**
     * iPhone
     */

    var isIPhone = function (userAgent) {
      return /iphone/i.test(userAgent.toLowerCase());
    };
    /**
     * iPad
     */

    var isIPad = function (userAgent) {
      return /ipad/i.test(userAgent.toLowerCase());
    };
    /**
     * Windows App
     */

    var isWinApp = function (userAgent) {
      return isWin(userAgent) && isCalendarApp(userAgent);
    };
    /**
     * mac App
     */

    var isMacApp = function (userAgent) {
      return !isIOS(userAgent) && isMac(userAgent) && isCalendarApp(userAgent);
    };
    /**
     * ie 10
     */

    var isIE10 = function (navigator) {
      return navigator.appName === 'Microsoft Internet Explorer' && parseInt(navigator.appVersion.split(';')[1].replace(/[ ]/g, '').replace('MSIE', ''), 10) === 10;
    };
    /**
     * 微信浏览器
     */

    var isWeChat = function (ua) {
      return /micromessenger/i.test(ua) && !/wxwork/i.test(ua);
    };
    /**
     * 企业微信
     */

    var isWxwork = function () {
      return navigator.userAgent.toLowerCase().indexOf('wxwork') !== -1;
    };
    /*
     * 企业微信私有化
     */

    var isWxworkLocal = function () {
      return navigator.userAgent.toLowerCase().indexOf('wxworklocal') !== -1;
    };
    /**
     * Saas企业微信（非私有化企业微信）
     */

    var isWxWorkSaas = function () {
      return isWxwork() && !isWxworkLocal();
    };
    /**
     * Determine whether QBCore version of the web browser embedded in the WeiXin PC client
     * is less than the given parameter QBCoreVer.
     * @param QBCoreVer the QBCore version you want do compare against
     */
    // export const isWeiXinQBCoreLt = (QBCoreVer: any) => {
    //   const { userAgent } = window.navigator;
    //   const qbCoreInfo = userAgent.match(/QBCore\/([\d.]+)/i);
    //   const isWeiXin = /MicroMessenger/i.test(userAgent);
    //   return isWeiXin
    //     && !userAgent.includes('wxwork')
    //     && qbCoreInfo
    //     && qbCoreInfo.length >= 2
    //     && compareVersion(qbCoreInfo[1], QBCoreVer) < 0;
    // };

    /**
     * 企业微信的userAgent：Mozilla/5.0 (Linux; Android 9; Pixel 2 Build/PQ2A.190405.003; wv)
     * AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/66.0.3359.126
     * MQQBrowser/6.2 TBS/044605 Mobile Safari/537.36 wxwork/2.7.8 MicroMessenger/7.0.1 NetType/WIFI Language/zh
     */
    // export const isWeiXinGte656 = () => {
    //   const { userAgent } = window.navigator;
    //   const wxInfo = userAgent.match(/MicroMessenger\/([\d.]+)/i);
    //   return (
    //     !userAgent.includes('wxwork')
    //     && wxInfo
    //     && wxInfo.length >= 2
    //     && compareVersion(wxInfo[1], '6.5.6') >= 0
    //   );
    // };

    /**
     * 企业微信版本是否大于3.1.2
     */

    var isWxWorkGte312 = function () {
      var userAgent = window.navigator.userAgent;
      var wxInfo = userAgent.match(/wxwork\/([\d.]+)/i);
      console.log('>>>>wxInfo', wxInfo);
      return userAgent.includes('wxwork') && wxInfo && wxInfo.length >= 2 && wxInfo[1] >= '3.1.2';
    };
    var getOsName = function () {
      /**
       * windows
       */
      if (navigator.appVersion.includes('Win')) {
        return 'windows';
      }
      if (navigator.appVersion.includes('Android')) {
        return 'android';
      }
      /**
       * ios
       */
      // iOS和Mac的顺序不能变，经测试发现Mac的浏览器里会有iOS的字样

      if (navigator.appVersion.includes('iPhone') || navigator.appVersion.includes('iPad')) {
        return 'ios';
      }
      /**
       * mac
       */

      var isMac = navigator.platform === 'Mac68K' || navigator.platform === 'MacPPC' || navigator.platform === 'Macintosh' || navigator.platform === 'MacIntel' || navigator.appVersion.includes('Mac');
      if (isMac) {
        return 'mac';
      }
      if (navigator.userAgent.includes('Linux')) {
        return 'linux';
      }
      return 'unknown';
    };
    /**
     * Linux 系统
     */

    var isLinux = function () {
      var os = getOsName();
      if (os === 'linux') {
        return true;
      }
      return false;
    };
    var isWindowsWechat = function () {
      return /WindowsWechat/.test(navigator.userAgent);
    };
    var isEdge = function () {
      return /Edge/.test(navigator.userAgent);
    };
    var isFF = function () {
      return navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
    };
    var isIE = function () {
      return /Trident/.test(navigator.userAgent);
    };
    /**
     * 企业微信安卓版
     */

    var isWxworkInAndroid = function (ua) {
      return /Android/i.test(ua) && /wxwork/i.test(ua);
    };
    /**
     * 获取系统的版本号：windows、android、mac、ios
     */

    var getSystemVersion = function () {
      var os = getOsName();
      var userAgent = window.navigator.userAgent;
      var info = null;
      if (os === 'windows') {
        info = userAgent.toLocaleLowerCase().match(/windows nt ([\d.]+)/i);
      } else if (os === 'android') {
        info = userAgent.toLocaleLowerCase().match(/android ([\d.]+)/i);
      } else if (os === 'mac') {
        info = userAgent.toLocaleLowerCase().replace(/_/g, '.').match(/mac os x ([\d.]+)/i);
      } else if (os === 'ios') {
        info = userAgent.toLocaleLowerCase().replace(/_/g, '.').match(/os ([\d.]+)/i);
      } else {
        return 'unknown';
      }
      return info && info.length >= 2 && info[1] || 'unknown';
    };
    /**
     * 获取设备语言，目前仅支持：繁体中文、简体中文、英语
     */

    var getSystemLanguage = function () {
      var language = navigator.language.toLocaleLowerCase();
      if (language === 'zh-tw' || language === 'zh-hk' || language === 'zh-mo') {
        return '繁体中文';
      }
      if (language.indexOf('zh') > -1) {
        return '简体中文';
      }
      if (language.indexOf('en') > -1) {
        return '英语';
      }
      return 'unknown';
    };
    /**
     * 获取系统时区
     */

    var getSystemTimeZone = function () {
      if (Intl) {
        var arr = new Date().toTimeString().split(' ');
        var str = arr[2].substring(1, arr[2].length - 1);
        var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.split('/');
        return "(".concat(arr[1], ")").concat(str, "-").concat(timeZone[1]);
      }
      return 'unknown';
    }; // 是否搜狗浏览器

    var isSe = function (userAgent) {
      return /se\s2\.x/i.test(userAgent.toLowerCase());
    };
    var isSafari = function (userAgent) {
      var ua = userAgent.toLowerCase();
      var fd = function (ss) {
        return ua.indexOf(ss) > -1;
      };
      var nf = function (ss) {
        return ua.indexOf(ss) === -1;
      };
      var a = fd('safari/');
      var b = nf('chrome/');
      var c = nf('qq/') && nf('mqqbrowser');
      return a && b && c;
    };
    var isMobile = function () {
      if (isSafari(navigator.userAgent) && navigator.maxTouchPoints) {
        // some iPads just does not have `iPad` in UA
        return true;
      }
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }; // warn: iPad 13.5 系统会判断为false

    var isMobileServer = function (ua) {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
    };
    var isMeetingApp = function () {
      return !!navigator.userAgent.match(/app\/tencent_wemeet/);
    };
    exports.getOsName = getOsName;
    exports.getSystemLanguage = getSystemLanguage;
    exports.getSystemTimeZone = getSystemTimeZone;
    exports.getSystemVersion = getSystemVersion;
    exports.isAndroid = isAndroid;
    exports.isCalendarApp = isCalendarApp;
    exports.isEdge = isEdge;
    exports.isFF = isFF;
    exports.isIE = isIE;
    exports.isIE10 = isIE10;
    exports.isIOS = isIOS;
    exports.isIPad = isIPad;
    exports.isIPhone = isIPhone;
    exports.isLinux = isLinux;
    exports.isMac = isMac;
    exports.isMacApp = isMacApp;
    exports.isMeetingApp = isMeetingApp;
    exports.isMobile = isMobile;
    exports.isMobileServer = isMobileServer;
    exports.isSafari = isSafari;
    exports.isSe = isSe;
    exports.isWeChat = isWeChat;
    exports.isWin = isWin;
    exports.isWinApp = isWinApp;
    exports.isWindowsWechat = isWindowsWechat;
    exports.isWxWorkGte312 = isWxWorkGte312;
    exports.isWxWorkSaas = isWxWorkSaas;
    exports.isWxwork = isWxwork;
    exports.isWxworkInAndroid = isWxworkInAndroid;
    exports.isWxworkLocal = isWxworkLocal;
  });
  _commonjsHelpersAad7be82.unwrapExports(os);
  os.getOsName;
  os.getSystemLanguage;
  os.getSystemTimeZone;
  os.getSystemVersion;
  os.isAndroid;
  var os_6 = os.isCalendarApp;
  os.isEdge;
  os.isFF;
  os.isIE;
  os.isIE10;
  os.isIOS;
  os.isIPad;
  os.isIPhone;
  os.isLinux;
  os.isMac;
  os.isMacApp;
  os.isMeetingApp;
  os.isMobile;
  os.isMobileServer;
  os.isSafari;
  os.isSe;
  os.isWeChat;
  os.isWin;
  os.isWinApp;
  os.isWindowsWechat;
  os.isWxWorkGte312;
  os.isWxWorkSaas;
  os.isWxwork;
  os.isWxworkInAndroid;
  os.isWxworkLocal;
  var randomString_1 = _commonjsHelpersAad7be82.createCommonjsModule(function (module, exports) {
    Object.defineProperty(exports, '__esModule', {
      value: true
    });

    /**
     * 生成随机字符串，默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1
     * @param len 要生成字符串的长度
     */
    function randomString(len) {
      if (len === void 0) {
        len = 9;
      }
      var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
      var string = '';
      for (var i = 0; i < len; i++) {
        string += chars[Math.floor(Math.random() * chars.length)];
      }
      return string;
    }
    exports.randomString = randomString;
  });
  _commonjsHelpersAad7be82.unwrapExports(randomString_1);
  var randomString_2 = randomString_1.randomString;
  var getToken = function (allCookies) {
    var token = '';
    // 多层保存避免token拿不到
    if (typeof window !== 'undefined') {
      token = window.currentTicket;
    }
    if (!token && typeof sessionStorage !== 'undefined') {
      token = sessionStorage.getItem('ticket');
    }
    return token || allCookies.ticket || allCookies.we_meet_token || allCookies.token;
  };
  // 获取uid和appid
  var getIdSafe = function (key) {
    var token = '';
    // 多层保存避免token拿不到
    if (typeof window !== 'undefined') {
      // @ts-ignore
      token = window["safe_id_".concat(key)];
    }
    if (!token && typeof sessionStorage !== 'undefined') {
      token = sessionStorage.getItem("safe_id_".concat(key));
    }
    return token;
  };
  var getReqConfig = function (ctx, token, getNextUa, getCookies) {
    return tslib_es629fb0173.__awaiter(void 0, void 0, void 0, function () {
      var userAgent, allCookies, instanceId, cToken, appId, appUid, queryParams, config, cookies$1, pathUrl, referer;
      var _a, _b, _c, _d, _e, _f, _g, _h;
      return tslib_es629fb0173.__generator(this, function (_j) {
        userAgent = (getNextUa || getUserAgent)(ctx);
        allCookies = (getCookies || cookies4cd4f1c3.getAllCookies)(ctx) || {};
        instanceId = getInstanceId(userAgent);
        cToken = token || getToken(allCookies);
        appId = getIdSafe('appId') || allCookies.app_id || ((_a = ctx === null || ctx === void 0 ? void 0 : ctx.query) === null || _a === void 0 ? void 0 : _a.app_id) || allCookies.corp_id || '';
        appUid = getIdSafe('appUid') || allCookies.app_uid || ((_b = ctx === null || ctx === void 0 ? void 0 : ctx.query) === null || _b === void 0 ? void 0 : _b.app_uid) || '';
        queryParams = {
          c_instance_id: instanceId.id || '5',
          c_os_model: 'web',
          c_os: 'web',
          c_nonce: randomString_2(8),
          c_os_version: encodeURIComponent(userAgent),
          c_timestamp: +new Date(),
          c_app_id: appId,
          c_app_uid: appUid,
          c_platform: os_6(userAgent) || isWeMeetApp(userAgent) ? '5' : '0',
          c_token: cToken,
          c_app_version: allCookies.app_version || allCookies.app_version || tencentAppVersion(userAgent) || '',
          platform: instanceId.name || 'web',
          app_id: appId,
          c_lang: ((_c = ctx === null || ctx === void 0 ? void 0 : ctx.query) === null || _c === void 0 ? void 0 : _c.lang) || 'zh-CN'
        };
        config = {
          params: queryParams
        };
        if (cookies4cd4f1c3.isServer && ctx) {
          cookies$1 = ((_e = (_d = ctx.req) === null || _d === void 0 ? void 0 : _d.headers) === null || _e === void 0 ? void 0 : _e.cookie) || '';
          pathUrl = (_f = ctx.req) === null || _f === void 0 ? void 0 : _f.url;
          referer = ((_h = (_g = ctx.req) === null || _g === void 0 ? void 0 : _g.headers) === null || _h === void 0 ? void 0 : _h.referer) || '';
          config.headers = {
            Cookie: cookies$1,
            Referer: referer || "https://meeting.tencent.com".concat(pathUrl),
            // @ts-ignore
            'app-uid': appUid,
            // @ts-ignore
            'app-id': appId,
            platform: 'web' // web表明是h5来的请求
          };
        }

        return [2 /*return*/, config];
      });
    });
  };

  /*
   * @Date: 2022-05-27 17:29:57
   * @Author: manuelzhao
   * @LastEditors: manuelzhao manuelzhao@tencent.com
   * @LastEditTime: 2023-03-12 23:34:44
   * @Description: 获取北极星配置
   * @FilePath: /calendar-framework/packages/request/polaris/index.ts
   */
  /**
   * 通过路径与获取L5配置
   * @param path 路径
   */
  var getPolarisConfig = function (path) {
    var _a, _b;
    // @ts-ignore
    var polarisMap = ((_b = (_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.pugins) === null || _b === void 0 ? void 0 : _b.request) || polarisMap;
    var config = polarisMap.find(function (_a) {
      var prefix = _a.prefix;
      return path.startsWith(prefix);
    });
    if (config === null || config === void 0 ? void 0 : config.polaris) {
      // 通过域名匹配对应L5
      var deployEnv = process.env.DEPLOY_ENV || 'production';
      var polarisConfig = config.polaris[deployEnv];
      // logger.info('polarisConfig: %j', polarisConfig);
      return {
        webPrefix: config.prefix,
        polarisConfig: polarisConfig
      };
    }
    return {};
  };
  var emptyCallBack = function () {};
  /**
   * 根据域名获取cgi地址
   * @param ctx
   * @returns
   */
  var getCgiDomain = function (ctx) {
    var _a, _b;
    var hostName = (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx.req) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b.host;
    if (!cookies4cd4f1c3.isServer) {
      hostName = location.host;
    }
    // 特殊逻辑
    if (hostName === 'source.meeting.qq.com') {
      return 'meeting.tencent.com';
    }
    return hostName;
  };
  function getServerUrl(path, hostName, consumer) {
    return tslib_es629fb0173.__awaiter(this, void 0, void 0, function () {
      var _a, webPrefix, polarisConfig, polaris, isCICD, metaData, response_1, _b, host, port;
      return tslib_es629fb0173.__generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            if (!consumer) return [3 /*break*/, 2];
            _a = getPolarisConfig(path), webPrefix = _a.webPrefix, polarisConfig = _a.polarisConfig;
            polaris = polarisConfig;
            if (!(polaris && webPrefix)) return [3 /*break*/, 2];
            isCICD = process.env.DEPLOY_ENV === 'ci';
            metaData = {};
            if (isCICD) {
              metaData = {
                env: process.env.env
              };
            }
            return [4 /*yield*/, consumer.select(polaris.namespace, polaris.service, metaData)];
          case 1:
            response_1 = _c.sent();
            if (!response_1) {
              return [2 /*return*/, {
                url: "http://".concat(polaris.default),
                callback: emptyCallBack
              }];
            }
            _b = response_1.instance, host = _b.host, port = _b.port;
            return [2 /*return*/, {
              url: "http://".concat(host, ":").concat(port).concat(path.replace(webPrefix, '')),
              callback: function (success, cost, code) {
                response_1.update(success, cost, code);
              }
            }];
          case 2:
            // 获取配置失败
            return [2 /*return*/, {
              url: "https://".concat(hostName).concat(path),
              callback: emptyCallBack
            }];
        }
      });
    });
  }
  var getUrl = function (_a) {
    var _b = _a.prefix,
      prefix = _b === void 0 ? '/' : _b,
      path = _a.path,
      ctx = _a.ctx,
      getHostName = _a.getHostName,
      consumer = _a.consumer;
    return tslib_es629fb0173.__awaiter(void 0, void 0, void 0, function () {
      var p, hostName, protocol;
      return tslib_es629fb0173.__generator(this, function (_c) {
        p = "".concat(prefix).concat(path);
        hostName = (getHostName || getCgiDomain)(ctx);
        protocol = 'https://';
        if (prefix.match(/http(s)?:\/\//)) {
          return [2 /*return*/, {
            url: "".concat(prefix).concat(path),
            callback: emptyCallBack
          }];
        }
        // browser
        if (!cookies4cd4f1c3.isServer || !ctx) {
          return [2 /*return*/, {
            url: "".concat(protocol).concat(hostName).concat(p),
            callback: emptyCallBack
          }];
        }
        // server product
        return [2 /*return*/, getServerUrl(p, hostName, consumer)];
      });
    });
  };
  var asyncPromise = null;
  var getNodeAegis = function () {
    if (asyncPromise) {
      return asyncPromise;
    }
    asyncPromise = Promise.resolve().then(function () {
      return /*#__PURE__*/_interopNamespace(aegisNodeSdk);
    });
    return asyncPromise;
  };

  /*
   * @Date: 2022-06-06 14:48:36
   * @Author: manuelzhao
   * @LastEditors: manuelzhao manuelzhao@tencent.com
   * @LastEditTime: 2023-03-13 21:11:01
   * @Description: 是否扫描
   * @FilePath: /calendar-framework/packages/request/src/http/is-tencent-security-scan.ts
   */
  /**
   * 是否腾讯安全扫描
   * @param ctx
   */
  function isTencentSecurityScan(ctx, getNextUa) {
    var _a, _b;
    // nodeJS扫描，header有标识
    // request.headers['Tencent-LeakScan'] || request.headers['tencent-leakscan']
    // TST(Tencent Security Team)
    var securityScanHeader;
    if (cookies4cd4f1c3.isServer) {
      securityScanHeader = ((_a = ctx === null || ctx === void 0 ? void 0 : ctx.req) === null || _a === void 0 ? void 0 : _a.headers['Tencent-LeakScan']) || ((_b = ctx === null || ctx === void 0 ? void 0 : ctx.req) === null || _b === void 0 ? void 0 : _b.headers['tencent-leakscan']) || '';
    }
    // web客户端
    securityScanHeader = (getNextUa || getUserAgent)(ctx);
    var isScan = securityScanHeader && securityScanHeader.indexOf('TST(Tencent_Security_Team)') > -1;
    return isScan;
  }

  /*
   * @Date: 2022-01-24 10:52:17
   * @Author: manuelzhao
   * @LastEditors: manuelzhao
   * @LastEditTime: 2022-01-24 10:59:04
   * @Description: 启动时判断环境
   * @FilePath: /WeCalendarWebSSR/config/env.js
   */
  const isDev = process.env.NODE_ENV === 'development';
  const isTestDev = process.env.TEST_ENV;
  var env = () => {
    if (isDev) {
      return 'dev';
    }
    if (isTestDev) {
      return 'test';
    }
    return 'prod';
  };
  var env_1 = env;
  var nodeAegis;
  var envType = env_1();
  var id = process.env.AEGIS_ID;
  var initNodeAegis = function (ctx, getNextCookie) {
    return tslib_es629fb0173.__awaiter(void 0, void 0, void 0, function () {
      var allCookies, uin, Aegis;
      return tslib_es629fb0173.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (nodeAegis) {
              return [2 /*return*/];
            }

            allCookies = (getNextCookie || cookies__default["default"])(ctx || {});
            uin = allCookies.app_uid || '';
            return [4 /*yield*/, getNodeAegis()];
          case 1:
            Aegis = _a.sent().default;
            nodeAegis = new Aegis({
              id: id,
              uin: uin,
              selector: {
                type: 'host'
              },
              // 先用这个字段来填 referer
              ext2: ctx === null || ctx === void 0 ? void 0 : ctx.req.headers.referer,
              // 先用这个字段来填 ua
              ext3: ctx === null || ctx === void 0 ? void 0 : ctx.req.headers['user-agent']
            });
            envType === 'dev' && console.log('inited nodeAegis------');
            return [2 /*return*/];
        }
      });
    });
  };
  // 设置用户标示
  var setAegisUin = function (ctx, customUin, getNextCookie) {
    return tslib_es629fb0173.__awaiter(void 0, void 0, void 0, function () {
      var allCookies, uin;
      return tslib_es629fb0173.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            allCookies = (getNextCookie || cookies__default["default"])(ctx || {});
            uin = allCookies.app_uid || customUin || '';
            if (!!nodeAegis) return [3 /*break*/, 2];
            return [4 /*yield*/, initNodeAegis(ctx, getNextCookie)];
          case 1:
            _a.sent();
            _a.label = 2;
          case 2:
            // 避免用到上一个请求的uid
            nodeAegis.setConfig({
              uin: uin
            });
            return [2 /*return*/];
        }
      });
    });
  };
  /**
   * 白名单日志上报
   * @param msg
   * @param ctx
   */
  var nodeAegisInfo = function (msg, ctx, getNextUa, getNextCookie) {
    return tslib_es629fb0173.__awaiter(void 0, void 0, void 0, function () {
      var _a, _b;
      return tslib_es629fb0173.__generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            if (isTencentSecurityScan(ctx, getNextUa)) {
              return [2 /*return*/];
            }

            if (!cookies4cd4f1c3.isServer && typeof window !== 'undefined') {
              // @ts-ignore
              (_b = (_a = window === null || window === void 0 ? void 0 : window.nextAegis) === null || _a === void 0 ? void 0 : _a.infoAll) === null || _b === void 0 ? void 0 : _b.call(_a, msg);
              return [2 /*return*/];
            }

            if (!!nodeAegis) return [3 /*break*/, 2];
            return [4 /*yield*/, initNodeAegis(ctx, getNextCookie)];
          case 1:
            _c.sent();
            _c.label = 2;
          case 2:
            setAegisUin(ctx, '', getNextCookie);
            nodeAegis.info(msg);
            return [2 /*return*/];
        }
      });
    });
  };
  /**
   * 全量日志上报
   * @param msg
   * @param ctx
   */
  var nodeAegisInfoAll = function (msg, ctx, getNextUa, getNextCookie) {
    return tslib_es629fb0173.__awaiter(void 0, void 0, void 0, function () {
      var _a, _b;
      return tslib_es629fb0173.__generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            // console.log('ctx', ctx?.req);
            if (isTencentSecurityScan(ctx, getNextUa)) {
              return [2 /*return*/];
            }

            if (!cookies4cd4f1c3.isServer) {
              // @ts-ignore
              (_b = (_a = window.nextAegis) === null || _a === void 0 ? void 0 : _a.infoAll) === null || _b === void 0 ? void 0 : _b.call(_a, msg);
              return [2 /*return*/];
            }

            if (!!nodeAegis) return [3 /*break*/, 2];
            return [4 /*yield*/, initNodeAegis(ctx, getNextCookie)];
          case 1:
            _c.sent();
            _c.label = 2;
          case 2:
            setAegisUin(ctx, '', getNextCookie);
            nodeAegis.infoAll(msg);
            envType === 'dev' && console.log('nodeAegisInfoAll:', msg);
            return [2 /*return*/];
        }
      });
    });
  };
  /**
   * 上报接口错误
   * @param msg
   * @param ctx
   */
  var nodeAegisReportError = function (msg, ctx, getNextUa, getNextCookie) {
    return tslib_es629fb0173.__awaiter(void 0, void 0, void 0, function () {
      return tslib_es629fb0173.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!cookies4cd4f1c3.isServer || isTencentSecurityScan(ctx, getNextUa)) {
              return [2 /*return*/];
            }

            if (!!nodeAegis) return [3 /*break*/, 2];
            return [4 /*yield*/, initNodeAegis(ctx, getNextCookie)];
          case 1:
            _a.sent();
            _a.label = 2;
          case 2:
            setAegisUin(ctx, '', getNextCookie);
            nodeAegis.report(new Error(msg));
            return [2 /*return*/];
        }
      });
    });
  };
  /**
   * 上报统计
   * @param key
   * @param ctx
   */
  var nodeAegisReportEvent = function (key, ctx, getNextUa, getNextCookie) {
    return tslib_es629fb0173.__awaiter(void 0, void 0, void 0, function () {
      return tslib_es629fb0173.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!cookies4cd4f1c3.isServer || isTencentSecurityScan(ctx, getNextUa)) {
              return [2 /*return*/];
            }

            if (!!nodeAegis) return [3 /*break*/, 2];
            return [4 /*yield*/, initNodeAegis(ctx, getNextCookie)];
          case 1:
            _a.sent();
            _a.label = 2;
          case 2:
            setAegisUin(ctx, '', getNextCookie);
            nodeAegis.reportEvent(key);
            return [2 /*return*/];
        }
      });
    });
  };
  /**
   * 测速上报
   * @param key
   * @param ctx
   */
  var nodeAegisReportTime = function (key, time, ctx, getNextUa, getNextCookie) {
    return tslib_es629fb0173.__awaiter(void 0, void 0, void 0, function () {
      return tslib_es629fb0173.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!cookies4cd4f1c3.isServer || isTencentSecurityScan(ctx, getNextUa)) {
              return [2 /*return*/];
            }

            if (!!nodeAegis) return [3 /*break*/, 2];
            return [4 /*yield*/, initNodeAegis(ctx, getNextCookie)];
          case 1:
            _a.sent();
            _a.label = 2;
          case 2:
            setAegisUin(ctx, '', getNextCookie);
            nodeAegis.reportTime(key, time);
            return [2 /*return*/];
        }
      });
    });
  };

  exports.getReqConfig = getReqConfig;
  exports.getUrl = getUrl;
  exports.nodeAegisInfo = nodeAegisInfo;
  exports.nodeAegisInfoAll = nodeAegisInfoAll;
  exports.nodeAegisReportError = nodeAegisReportError;
  exports.nodeAegisReportEvent = nodeAegisReportEvent;
  exports.nodeAegisReportTime = nodeAegisReportTime;
});
unwrapExports(nodeAegisE2e89eff);
nodeAegisE2e89eff.getReqConfig;
nodeAegisE2e89eff.getUrl;
nodeAegisE2e89eff.nodeAegisInfo;
nodeAegisE2e89eff.nodeAegisInfoAll;
nodeAegisE2e89eff.nodeAegisReportError;
nodeAegisE2e89eff.nodeAegisReportEvent;
nodeAegisE2e89eff.nodeAegisReportTime;

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var Axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);
var reportHttpError = function (e, ctx, url, config) {
  var msg = "CGI Request Error: [url]: ".concat(url, ", [data]: ").concat(JSON.stringify(config), ", [error info]: ").concat(e);
  if (cookies4cd4f1c3.isServer && ctx) {
    nodeAegisE2e89eff.nodeAegisReportError(msg, ctx);
  } else if (window.nextAegis) {
    window.nextAegis.report(msg, e);
  }
};
// 业务逻辑是否存在异常
// 不同接口的返回码不一样，需要枚举兼容
var isLogicSuccess = function (response) {
  var _a, _b;
  return ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.code) === 0 || ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.code) === 200;
};
var CalendarRequest = /** @class */function () {
  // ticketToken: string;
  // 初始化请求库
  function CalendarRequest(_a) {
    var timeout = _a.timeout,
      base_url = _a.base_url,
      _b = _a.headers,
      headers = _b === void 0 ? {} : _b,
      _c = _a.requestMiddleware,
      requestMiddleware = _c === void 0 ? [] : _c,
      _d = _a.responseMiddleware,
      responseMiddleware = _d === void 0 ? [] : _d,
      _e = _a.extendsPlugin,
      extendsPlugin = _e === void 0 ? [] : _e,
      onTokenCheckFail = _a.onTokenCheckFail;
    var _this = this;
    this.http = Axios__default["default"].create({
      timeout: timeout
    });
    this.onTokenCheckFail = onTokenCheckFail;
    this.http.interceptors.request.use(function (config) {
      var axiosConfig = config;
      axiosConfig.baseURL = base_url;
      axiosConfig.headers = tslib_es629fb0173.__assign(tslib_es629fb0173.__assign({
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }, config.headers), headers);
      return axiosConfig;
    });
    requestMiddleware.map(function (item) {
      _this.http.interceptors.request.use(item);
    });
    responseMiddleware.map(function (item) {
      _this.http.interceptors.response.use(item);
    });
    extendsPlugin.map(function (item) {
      var _a;
      (_a = item.init) === null || _a === void 0 ? void 0 : _a.call(item, _this);
    });
  }
  // post请求
  CalendarRequest.prototype.post = function (prefix, path, data, ctx, query, rawRes, axiosConfig) {
    var _a, _b, _c;
    if (query === void 0) {
      query = {};
    }
    return tslib_es629fb0173.__awaiter(this, void 0, void 0, function () {
      var prefetch, res, config, postParams, _d, url, callback, reportPath, startTime, response, httpDuration, reportLogData;
      var _this = this;
      return tslib_es629fb0173.__generator(this, function (_e) {
        switch (_e.label) {
          case 0:
            prefetch = this.getPrefetchData(path);
            if (!prefetch) return [3 /*break*/, 2];
            return [4 /*yield*/, prefetch];
          case 1:
            res = _e.sent();
            this.clearPrefetchData(path);
            if (res) {
              return [2 /*return*/, res];
            }
            _e.label = 2;
          case 2:
            return [4 /*yield*/, nodeAegisE2e89eff.getReqConfig(ctx)];
          case 3:
            config = _e.sent();
            postParams = [prefix, path, data, ctx, query, rawRes, axiosConfig];
            config.params = tslib_es629fb0173.__assign(tslib_es629fb0173.__assign({}, config.params), query);
            if (axiosConfig) {
              config = tslib_es629fb0173.__assign(tslib_es629fb0173.__assign({}, config), axiosConfig);
            }
            return [4 /*yield*/, nodeAegisE2e89eff.getUrl({
              prefix: prefix,
              path: path,
              ctx: ctx
            })];
          case 4:
            _d = _e.sent(), url = _d.url, callback = _d.callback;
            reportPath = prefix + path;
            startTime = new Date().getTime();
            return [4 /*yield*/, this.http.post(url, data, config).catch(function (e) {
              return tslib_es629fb0173.__awaiter(_this, void 0, void 0, function () {
                var _a;
                return tslib_es629fb0173.__generator(this, function (_b) {
                  callback(false, 0, '-1');
                  // 错误统一上报
                  reportHttpError(e, ctx, url, config);
                  if (((_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.status) === 401 && this.onTokenCheckFail) {
                    return [2 /*return*/, this.onTokenCheckFail(postParams, this.post)];
                  }
                  return [2 /*return*/, Promise.reject(e)];
                });
              });
            })];
          case 5:
            response = _e.sent();
            httpDuration = new Date().getTime() - startTime;
            callback(true, httpDuration, '0');
            ctx && nodeAegisE2e89eff.nodeAegisReportTime(reportPath, httpDuration, ctx);
            if (ctx) {
              reportLogData = "\n        \u3010method\u3011: post,\n        \u3010url\u3011: ".concat(url, ",\n        \u3010httpDuration\u3011:").concat(httpDuration, ",\n        \u3010status\u3011: ").concat(JSON.stringify(response.status), ",\n        \u3010request\u3011: ").concat(JSON.stringify(data), ",\n        \u3010params\u3011:").concat(JSON.stringify(((_a = response === null || response === void 0 ? void 0 : response.config) === null || _a === void 0 ? void 0 : _a.params) || {}), ",\n        \u3010response\u3011: ").concat(JSON.stringify(response.data));
              // 业务逻辑错误
              if (!isLogicSuccess(response)) {
                nodeAegisE2e89eff.nodeAegisInfoAll("Response Logic Error - ".concat(path, " :").concat(reportLogData), ctx);
                // 统计服务端业务错误数量
                nodeAegisE2e89eff.nodeAegisReportEvent("".concat(response.data.code, "_").concat(response.data.message), ctx);
              }
              // 全量返回日志
              nodeAegisE2e89eff.nodeAegisInfoAll("Response : ".concat(reportLogData), ctx);
              // 白名单日志上报
              nodeAegisE2e89eff.nodeAegisInfo("Response - Detail :\n        ".concat(reportLogData, ",\n        [cookie]:").concat((_c = (_b = ctx === null || ctx === void 0 ? void 0 : ctx.req) === null || _b === void 0 ? void 0 : _b.headers) === null || _c === void 0 ? void 0 : _c.cookie), ctx);
            }
            if (cookies4cd4f1c3.isServer && response.status !== 200 || rawRes) {
              // 服务端错误。
              return [2 /*return*/, response];
            }
            return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
        }
      });
    });
  };
  // get请求
  CalendarRequest.prototype.get = function (prefix, path, query, ctx, rawRes) {
    var _a, _b;
    return tslib_es629fb0173.__awaiter(this, void 0, void 0, function () {
      var config, getParams, _c, url, callback, startTime, params, response, httpDuration, reportLogData;
      var _this = this;
      return tslib_es629fb0173.__generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            return [4 /*yield*/, nodeAegisE2e89eff.getReqConfig(ctx)];
          case 1:
            config = _d.sent();
            getParams = [prefix, path, query, ctx, rawRes];
            config.params = tslib_es629fb0173.__assign(tslib_es629fb0173.__assign({}, config.params), query);
            return [4 /*yield*/, nodeAegisE2e89eff.getUrl({
              path: path,
              prefix: prefix,
              ctx: ctx
            })];
          case 2:
            _c = _d.sent(), url = _c.url, callback = _c.callback;
            startTime = new Date().getTime();
            params = tslib_es629fb0173.__assign(tslib_es629fb0173.__assign({}, config.params), query);
            return [4 /*yield*/, this.http.get(url, tslib_es629fb0173.__assign(tslib_es629fb0173.__assign({}, config), {
              params: params
            })).catch(function (e) {
              return tslib_es629fb0173.__awaiter(_this, void 0, void 0, function () {
                var _a;
                return tslib_es629fb0173.__generator(this, function (_b) {
                  switch (_b.label) {
                    case 0:
                      callback(false, 0, '-1');
                      reportHttpError(e, ctx, url, config);
                      if (!(((_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.status) === 401 && this.onTokenCheckFail)) return [3 /*break*/, 2];
                      return [4 /*yield*/, this.onTokenCheckFail(getParams, this.get)];
                    case 1:
                      return [2 /*return*/, _b.sent()];
                    case 2:
                      return [2 /*return*/, Promise.reject(e)];
                  }
                });
              });
            })];
          case 3:
            response = _d.sent();
            httpDuration = new Date().getTime() - startTime;
            if (ctx) {
              reportLogData = "\n        \u3010method\u3011: get,\n        \u3010url\u3011: ".concat(url, ",\n        \u3010httpDuration\u3011:").concat(httpDuration, ",\n        \u3010status\u3011: ").concat(JSON.stringify(response.status), ",\n        \u3010request\u3011: ").concat(JSON.stringify(query), ",\n        \u3010params\u3011:").concat(JSON.stringify(((_a = response === null || response === void 0 ? void 0 : response.config) === null || _a === void 0 ? void 0 : _a.params) || {}), ",\n        \u3010traceID\u3011: ").concat((_b = response === null || response === void 0 ? void 0 : response.headers) === null || _b === void 0 ? void 0 : _b.traceid, ",\n        \u3010response\u3011: ").concat(JSON.stringify(response.data));
              // 全量返回日志
              nodeAegisE2e89eff.nodeAegisInfoAll("Response : ".concat(reportLogData), ctx);
              // console.log('reportLogData', reportLogData);
            }

            callback(true, httpDuration, '0');
            if (cookies4cd4f1c3.isServer && response.status !== 200 || rawRes) {
              // 服务端错误。
              return [2 /*return*/, response];
            }
            return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
        }
      });
    });
  };
  CalendarRequest.prototype.getPrefetchData = function (api) {
    var _a, _b;
    if (api && typeof window !== 'undefined' && window.prefetchApi) {
      return (_b = (_a = window.prefetchApi).getData) === null || _b === void 0 ? void 0 : _b.call(_a, api);
    }
    return null;
  };
  CalendarRequest.prototype.clearPrefetchData = function (api) {
    var _a, _b;
    if (api && typeof window !== 'undefined' && window.prefetchApi) {
      return (_b = (_a = window.prefetchApi).clearData) === null || _b === void 0 ? void 0 : _b.call(_a, api);
    }
  };
  return CalendarRequest;
}();
var client = CalendarRequest;

var requestIns = new client({
  timeout: 10000,
  responseMiddleware: [function (response) {
    if (response.data.code !== 0 && response.data.code !== 200) {
      return Promise.reject(response);
    }
    return response === null || response === void 0 ? void 0 : response.data;
  }]
});
/**
 * @description: 退出登录
 * @param {*} host 请求域名，默认为''
 * @return {*} Promise
 */
var logout = function (host) {
  if (host === void 0) {
    host = '';
  }
  return __awaiter(void 0, void 0, void 0, function () {
    var path;
    return __generator(this, function (_a) {
      path = '/v2/account/logout';
      return [2 /*return*/, requestIns.post("".concat(host, "/wemeet-tapi"), path, {})];
    });
  });
};
/**
 * @description: 用户是否可以切换账号
 * @param {*} host 请求域名，默认为''
 * @return {*} Promise
 */
var canChangeAccount = function (host) {
  if (host === void 0) {
    host = '';
  }
  return __awaiter(void 0, void 0, void 0, function () {
    var path;
    return __generator(this, function (_a) {
      path = '/v2/account/profile/change-account';
      return [2 /*return*/, requestIns.get("".concat(host, "/wemeet-tapi"), path, {}).then(function (data) {
        return data.is_can_change_account;
      })];
    });
  });
};
/**
 * @description: 获取用户信息
 * @param {*} host: 请求域名，默认为''
 * @return {*} Promise
 */
var refreshTokenOrGetCorpInfo = function (host) {
  if (host === void 0) {
    host = '';
  }
  var path = '/v2/account/login/refresh-token';
  return requestIns.post("".concat(host, "/wemeet-tapi"), path, {}).then(function (data) {
    return data;
  });
};

var isSafari = function (userAgent) {
  var ua = userAgent.toLowerCase();
  var fd = function (ss) {
    return ua.indexOf(ss) > -1;
  };
  var nf = function (ss) {
    return ua.indexOf(ss) === -1;
  };
  var a = fd('safari/');
  var b = nf('chrome/');
  var c = nf('qq/') && nf('mqqbrowser');
  return a && b && c;
};
var isMobile = function (userAgent) {
  if (isSafari(userAgent)) {
    // some iPads just does not have `iPad` in UA
    return true;
  }
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
}; // warn: iPad 13.5 系统会判断为false
var isWeChat = function (ua) {
  return /micromessenger/i.test(ua) && !/wxwork/i.test(ua);
};
var isMeetingApp = function (userAgent) {
  var _a;
  var ua = '';
  if (userAgent !== undefined) {
    ua = userAgent;
  } else if (typeof window !== 'undefined') {
    ua = ((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) || '';
  }
  return !!ua.match(/app\/tencent_wemeet/);
};

var clearSeesionInfo = function () {
  if (typeof window !== 'undefined') {
    sessionStorage.removeItem('wemeet:userInfo');
  }
};
var infoPromise = null;
/**
 * 先尝试从sessionStorage中获取，再尝试从接口中获取，都失败则返回null
 * 会议app获取的信息有不全的，所以统一请求后台接口获取个人信息
 * @param host 请求域名 默认为空
 * @returns 会议个人信息promise
 */
var getLoginUserInfo = function (host) {
  if (host === void 0) {
    host = '';
  }
  return __awaiter(void 0, void 0, void 0, function () {
    var userInfo;
    return __generator(this, function (_a) {
      userInfo = getUserInfoFromSession();
      if (userInfo) return [2 /*return*/, userInfo];
      if (infoPromise) return [2 /*return*/, infoPromise];
      infoPromise = refreshTokenOrGetCorpInfo(host).then(function (userData) {
        var userInfo = setSessionUserInfo(__assign$1({}, userData));
        return userInfo;
      }, function () {
        return null;
      });
      return [2 /*return*/, infoPromise];
    });
  });
};
// 从sessionStorage中获取用户信息
var getUserInfoFromSession = function () {
  if (typeof sessionStorage === 'undefined') return null;
  try {
    var userInfoStr = sessionStorage.getItem('wemeet:userInfo');
    if (userInfoStr) {
      return JSON.parse(userInfoStr);
    }
  } catch (error) {
    console.log(error);
  }
  return null;
};
// 设置用户信息到sessionStorage中
var setSessionUserInfo = function (userInfo) {
  if (typeof sessionStorage === 'undefined') return null;
  sessionStorage.setItem('wemeet:userInfo', JSON.stringify(userInfo));
  return userInfo;
};
// 是否已登录
var checkLogin = function () {
  return __awaiter(void 0, void 0, void 0, function () {
    var userInfo;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, getLoginUserInfo()];
        case 1:
          userInfo = _a.sent();
          if (userInfo === null) {
            return [2 /*return*/, false];
          }
          return [2 /*return*/, true];
      }
    });
  });
};
// 获取app用户信息
var getWemeetAppUserInfo = function (userAgent) {
  if (userAgent === void 0) {
    userAgent = '';
  }
  return __awaiter(void 0, void 0, void 0, function () {
    var win, ua, data, user, userInfo, err_1;
    var _a;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          if (typeof window === 'undefined') return [2 /*return*/, Promise.reject('非客户端环境')];
          win = window;
          ua = userAgent || ((_a = win === null || win === void 0 ? void 0 : win.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) || '';
          if (!isMeetingApp(ua)) return [2 /*return*/, null];
          _b.label = 1;
        case 1:
          _b.trys.push([1, 3,, 4]);
          data = (win === null || win === void 0 ? void 0 : win.wemeet).data;
          return [4 /*yield*/, data.getUserInfo()];
        case 2:
          user = _b.sent();
          userInfo = __assign$1(__assign$1({}, user), {
            app_id: user.appId,
            userid: user.appUid,
            crop_id: user.appId,
            app_uid: user.appUid,
            nick_name: user.nickname,
            avatar: user.avatarUrl
          });
          return [2 /*return*/, userInfo];
        case 3:
          err_1 = _b.sent();
          return [2 /*return*/, Promise.reject(err_1)];
        case 4:
          return [2 /*return*/];
      }
    });
  });
};

/**
 * 在app内重新获取Ticket和info登录，其他端跳转去登录页
 * @param loginType
 * @param extraUrlParams
 * @param userAgent ua
 * @param pageType {number} 2: 报名页，3: 活动页 适配voov版本
 */
var login = function (loginType, extraUrlParams, userAgent, pageType) {
  if (loginType === void 0) {
    loginType = 0;
  }
  if (extraUrlParams === void 0) {
    extraUrlParams = {};
  }
  if (userAgent === void 0) {
    userAgent = '';
  }
  return __awaiter(void 0, void 0, void 0, function () {
    var win, ua, params, redirectUrl;
    var _a;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          if (typeof window === 'undefined') return [2 /*return*/];
          win = window;
          ua = userAgent || ((_a = win === null || win === void 0 ? void 0 : win.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) || '';
          if (!(isMeetingApp(ua) && (win === null || win === void 0 ? void 0 : win.wemeet))) return [3 /*break*/, 2];
          return [4 /*yield*/, appLogin()];
        case 1:
          return [2 /*return*/, _b.sent()];
        case 2:
          params = __assign$1({
            login_type: loginType
          }, extraUrlParams);
          redirectUrl = getRedirectPathUrl();
          if (isWeChat(ua)) {
            wxLogin(redirectUrl, params, pageType);
          } else if (isMobile(ua)) {
            otherMobileLogin(redirectUrl, params, pageType);
          } else {
            pcLogin(redirectUrl, params, pageType);
          }
          return [2 /*return*/];
      }
    });
  });
};
/**
 * 退出登录
 * @param loginType
 * @returns 退出登录接口promise，自定义成功和失败逻辑
 */
var logOut = function (jump, host) {
  if (jump === void 0) {
    jump = true;
  }
  if (host === void 0) {
    host = '';
  }
  return logout(host).then(function () {
    if (typeof window === 'undefined') return;
    sessionStorage.clear();
    if (jump) window.location.href = "".concat(window.location.origin, "/index.html");
  });
};
/**
 * 切换账号
 * @param jump 是否自动跳转
 * @param appId 当前用户的appid，不传则尝试取sessionStorage中appid
 * @returns 会议通用切换账号的地址
 */
var changeAccount = function (jump, appId) {
  if (jump === void 0) {
    jump = true;
  }
  var sessionAppId = (getUserInfoFromSession() || {}).app_id;
  var queryObj = new URLSearchParams(location.search);
  queryObj.delete('redirect_link');
  queryObj.delete('redirect_type');
  queryObj.delete('appid');
  queryObj.delete('change-account');
  var redirectLink = encodeURIComponent("".concat(location.pathname, "?").concat(queryObj.toString()).slice(1));
  var jumpUrl = "/select-account-type.html?change-account=1&appid=".concat(appId || sessionAppId || '', "&redirect_type=2&redirect_link=").concat(redirectLink);
  if (jump && typeof window !== 'undefined') window.location.href = jumpUrl;
  return jumpUrl;
};
var safeSaveId = function (key, value) {
  sessionStorage.setItem(key, value);
  // window[key] = value;
};
// app内登录
var appLogin = function () {
  return __awaiter(void 0, void 0, void 0, function () {
    var win, data, user, ticketInfo, err_1;
    var _a, _b;
    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          win = window;
          _c.label = 1;
        case 1:
          _c.trys.push([1, 4,, 5]);
          data = (win === null || win === void 0 ? void 0 : win.wemeet).data;
          return [4 /*yield*/, getWemeetAppUserInfo()];
        case 2:
          user = _c.sent();
          return [4 /*yield*/, data.getTicket({
            type: 'W10'
          })];
        case 3:
          ticketInfo = _c.sent();
          cookie_2('app_uid', user.app_uid, {
            expires: 0.1,
            path: '/'
          });
          cookie_2('corp_id', user.app_id, {
            expires: 0.1,
            path: '/'
          });
          cookie_2('ticket', ticketInfo.ticket, {
            expires: 0.1,
            path: '/'
          });
          setSessionUserInfo(user);
          // 设置在sessionStorage上，可以重复使用
          safeSaveId('ticket', ticketInfo.ticket);
          safeSaveId('safe_id_appId', user.appId);
          safeSaveId('safe_id_appUid', user.appUid);
          return [2 /*return*/, true];
        case 4:
          err_1 = _c.sent();
          console.log("getAppInfo error:".concat(err_1));
          (_b = (_a = win === null || win === void 0 ? void 0 : win.nextAegis) === null || _a === void 0 ? void 0 : _a.infoAll) === null || _b === void 0 ? void 0 : _b.call(_a, "getAppInfo error:".concat(err_1));
          return [3 /*break*/, 5];
        case 5:
          return [2 /*return*/];
      }
    });
  });
};
// 微信登录
var wxLogin = function (redirectUrl, params, pageType) {
  var search = {
    redirect_link: encodeURIComponent(url_1(redirectUrl, __assign$1({}, params))),
    pagetype: 3
  };
  if (pageType) {
    search.pagetype = pageType;
  }
  var url = url_1("".concat(window.location.origin, "/v2/login/wechat"), search);
  window.location.replace(url);
};
// 其他移动端浏览器登录
var otherMobileLogin = function (redirectUrl, params, pageType) {
  var search = {
    redirect_link: encodeURIComponent(url_1(redirectUrl, __assign$1({}, params))),
    pagetype: 3
  };
  if (pageType) {
    search.pagetype = pageType;
  }
  var url = url_1("".concat(window.location.origin, "/mobile/login.html"), search);
  window.location.href = url;
};
// pc浏览器登录
var pcLogin = function (redirectUrl, params, pageType) {
  var search = {
    redirect_type: 2,
    redirect_link: encodeURIComponent(url_1(redirectUrl, __assign$1({}, params))),
    pagetype: 3
  };
  if (pageType) {
    search.pagetype = pageType;
  }
  var url = url_1("".concat(window.location.origin, "/qrcode-login.html"), search);
  window.location.href = url;
};
// 获取登录成功后的回跳地址
var getRedirectPathUrl = function () {
  var pathname = location.pathname ? location.pathname.substring(1, location.pathname.length) : '';
  if (pathname.indexOf('middle-login') !== -1) {
    return decodeURIComponent(url_3('redirect_link', window.location.href) || '');
  }
  var search = url_2(window.location.search, 'redirect_link');
  search = url_2(search, 'redirect_type');
  return pathname + search;
};

var init = function () {
  clearSeesionInfo(); // 页面刷新时清除storage，避免一直获取旧信息
  if (typeof window !== 'undefined' && isMeetingApp()) {
    appLogin(); // app打开后登录设置cookie
  }
};

init();
var index = {
  login: login,
  logOut: logOut,
  changeAccount: changeAccount,
  getLoginUserInfo: getLoginUserInfo,
  checkLogin: checkLogin
};

export { canChangeAccount, changeAccount, checkLogin, index as default, getLoginUserInfo, logOut, login };
